export default __webpack_public_path__ + "static/media/Banner - EarBuddyz ULTRA PRO.437b3263.jpg";